import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { TabletSoftReceivedGoodsReceiptsContainer } from "@/screens/Tablet/WarehouseReceiving/SoftReceived"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/_layout/soft-received")({
  validateSearch: zodValidator(createGoodsReceiptSearchSchema(GoodsReceiptSortField.SoftReceivedOn, SortingOrder.Desc)),
  component: TabletSoftReceivedGoodsReceiptsContainer,
})
